import React from "react";

export const RichText = (props) => {
  return <div dangerouslySetInnerHTML={{ __html: props.content }} {...props} />;
};
